import { ReactNode, useEffect } from 'react';

type ModalSize = 'sm' | 'lg' | 'xl';

interface ModalProps {
  id: string;
  title?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  size?: ModalSize;
  centered?: boolean;
  staticBackdrop?: boolean;
  keyboardDismiss?: boolean;
  showCloseButton?: boolean;
  dialogClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  scrollable?: boolean
  onClose?: () => void
}

export const Modal = ({
  id,
  title,
  children,
  footer,
  size,
  centered = true,
  staticBackdrop = false,
  keyboardDismiss = true,
  showCloseButton = true,
  dialogClassName = '',
  bodyClassName = '',
  footerClassName = '',
  scrollable = false,
  onClose = () => { }
}: ModalProps) => {
  const labelId = `${id}-label`;
  const dialogClasses = [
    'modal-dialog',
    size ? `modal-${size}` : '',
    centered ? 'modal-dialog-centered' : 'modal-dialog-centered',
    scrollable ? 'modal-dialog-scrollable' : '',
    dialogClassName,
  ]
    .filter(Boolean)
    .join(' ');

  const titleType = typeof title == 'string' ? true : false

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex={-1}
      aria-labelledby={labelId}
      aria-hidden="true"
      {...(staticBackdrop ? { 'data-bs-backdrop': 'static' } : {})}
      {...(!keyboardDismiss ? { 'data-bs-keyboard': 'false' } : {})}
    >
      <div className={dialogClasses}>
        <div className="modal-content">
          {(title || showCloseButton) && (
            <div className={`modal-header px-3 py-3 border-0 position-relative ${typeof title === 'string' ? '' : 'justify-content-center'}`}>
              {title && (
                typeof title === 'string' ? (
                  <h1 className="modal-title coupon_title fs-5" id={labelId}>
                    {title}
                  </h1>
                ) : (
                  title
                )
              )}
              {showCloseButton && (
                <button
                  type="button"
                  className="btn-close coupon_cross position-absolute top-0 end-0 m-3" style={{zIndex:"99"}}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={onClose}
                ></button>
              )}
            </div>
          )}

          {children && <div className={`modal-body  ${bodyClassName}`.trim()}>{children}</div>}

          {footer !== undefined && (
            <div className={`modal-footer ${footerClassName}`.trim()}>
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
